module.exports = __webpack_public_path__ + "img/frame (72).9f91c6e8.jpg";